module.exports = __webpack_public_path__ + "static/media/background_1920-2.c54eef50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg/background_1920-2.jpg
// module id = 1084
// module chunks = 0